export enum DeviceTypes {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
}
